import { format, getYear, subMonths, addMonths } from "date-fns";
// import useWindowDimensions from "./useWindowDimensions";
export interface IDatesForGraph {
  startDate: string;
  endDate: string;
}

const getDatesForGraph = (
  yearSelected: string,
  width: number
): IDatesForGraph => {
  //check if current year
  //check for the screen resolution
  //if current year, end date = current date, start date = end date - x, based on screen res
  //if not current year, check if year is in past.
  //if in past, end date = 31 December, start date = end date - x, based on screen res
  //if in the future, start date = 01 Jan, end date = start date + x, based on screen res
  //return [fromDate, endDate]
  //   if()

  //   const { width, height } = useWindowDimensions();

  const currentYear = getYear(new Date());
  if (currentYear === parseInt(yearSelected)) {
    //on mobile
    if (width <= 599) {
      return {
        startDate: format(subMonths(new Date(), 3), "yyyy-MM-dd"),
        endDate: format(new Date(), "yyyy-MM-dd"),
      };
    } else if (width > 599 && width < 820) {
      return {
        startDate: format(subMonths(new Date(), 4), "yyyy-MM-dd"),
        endDate: format(new Date(), "yyyy-MM-dd"),
      };
    } else {
      return {
        startDate: `${currentYear}-01-01`,
        // endDate: format(new Date(), "yyyy-MM-dd"),
        endDate: `${currentYear}-12-31`,
      };
    }
  } else if (currentYear > parseInt(yearSelected)) {
    if (width <= 599) {
      return {
        endDate: `${yearSelected}-12-31`,
        startDate: format(
          subMonths(new Date(parseInt(yearSelected), 12, 31), 3),
          "yyyy-MM-dd"
        ),
      };
    } else if (width > 599 && width < 820) {
      return {
        endDate: `${yearSelected}-12-31`,
        startDate: format(
          subMonths(new Date(parseInt(yearSelected), 12, 31), 4),
          "yyyy-MM-dd"
        ),
      };
    } else {
      return {
        endDate: `${yearSelected}-12-31`,
        startDate: `${yearSelected}-01-01`,
      };
    }
  } else {
    if (width <= 599) {
      return {
        startDate: `${yearSelected}-01-01`,
        endDate: format(
          addMonths(new Date(parseInt(yearSelected), 1, 1), 3),
          "yyyy-MM-dd"
        ),
      };
    } else if (width > 599 && width < 820) {
      return {
        startDate: `${yearSelected}-01-01`,
        endDate: format(
          addMonths(new Date(parseInt(yearSelected), 1, 1), 4),
          "yyyy-MM-dd"
        ),
      };
    } else {
      return {
        startDate: `${yearSelected}-01-01`,
        endDate: `${yearSelected}-12-31`,
      };
    }
    // return { startDate: "", endDate: "" };
  }
};

export default getDatesForGraph;
